<template>
    <div class="header d-flex justify-content-center">
<!--        <span class="material-icons">arrow_back</span>-->
        <div class="headerMain">
            <div style="margin-right:5px;"><p><b>Player:</b>{{ state.user.name }}</p> </div>
            <div v-if="state.game">
                <b>Game code: </b> {{ String(state.game.session).toUpperCase() }}
            </div>
        </div>
        <InviteShare v-if="state.game" compact />
    </div>
</template>

<script>
    import {state} from '@/engine/state.js'
    import InviteShare from '@/components/game/InviteShare.vue'

    export default {
        name: 'StatusHeader',
        components: {
            InviteShare,
        },
        data() {
            return {
                state,
            }
        }
    }
</script>

<style scoped>
    div.header {
        min-height: 3em;
        background-color: #006e6e;
        align-items: center;
        gap: 10px;
        padding: 4px 8px;
        position: relative;
        z-index: 30;
    }

    div.headerMain {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 0;
    }

    div.header p {
        margin: 0;
    }

    div.header > span.material-icons {
        font-size: 50px;
    }

    @media (max-width: 520px) {
        div.header {
            justify-content: space-between;
        }

        div.headerMain {
            display: block;
            text-align: left;
        }
    }
</style>
